import { convertSSToMMSS, keysToCamelCase, removeUndefinedValues, } from '@wix/wix-vod-shared/common';
import { FREE_VIDEO_DEAL_INFO } from '@wix/wix-vod-constants/common';
import { TRANSCODING_STATUSES, VIDEO_SOURCES, } from '../private/enums';
import { normalizeId } from '../normalizers/entity-id';
import { TrailerGenerationErrorType, } from '@wix/wix-vod-constants/api-types';
import { mapMediaInfoToLiveVideoStatus } from '@wix/wix-vod-api-site-based';
const DEFAULT_DOWNLOAD_OPTIONS = { allowDownload: false };
const normalizeTranscodingStatus = (status = TRANSCODING_STATUSES.NONE) => {
    if (_.includes(TRANSCODING_STATUSES, status)) {
        return status;
    }
    return TRANSCODING_STATUSES.NONE;
};
const mapUsedInLists = (usedInLists = []) => usedInLists.map((ref) => ref.itemId);
export const parseVideoItem = (itemData) => {
    const camelCasedItemData = keysToCamelCase(itemData);
    const { itemId, externalId, listId, mediaStatus, trailerStatus, mediaInfo, mediaExternUrl, downloadOptions: { allowDownload } = DEFAULT_DOWNLOAD_OPTIONS, videoSource = VIDEO_SOURCES.COMPUTER, itemType, } = camelCasedItemData;
    const id = (itemId && normalizeId(itemId)) || externalId;
    const { customCoverUrl = null, createdTs: createdTsNum, updatedTs: updatedTsNum, publishTs: publishTsNum, usedInLists, } = camelCasedItemData;
    let { dealInfo, durationSec, durationStr, tags = [], categories = [], } = camelCasedItemData;
    const createdTs = new Date(createdTsNum * 1000);
    const updatedTs = new Date(updatedTsNum * 1000);
    const publishTs = publishTsNum ? new Date(publishTsNum * 1000) : null;
    const fileInputDurationSec = _.get(mediaInfo, 'fileInput.duration', 0);
    if (fileInputDurationSec) {
        durationSec = Math.floor(fileInputDurationSec / 1000);
        durationStr = convertSSToMMSS(durationSec);
    }
    if (!durationStr) {
        durationStr = convertSSToMMSS(durationSec);
    }
    const transcodingStatus = normalizeTranscodingStatus(mediaExternUrl ? TRANSCODING_STATUSES.READY : mediaStatus);
    const trailerTranscodingStatus = normalizeTranscodingStatus(trailerStatus);
    // external videos should be free
    if (mediaExternUrl) {
        dealInfo = FREE_VIDEO_DEAL_INFO;
    }
    tags = _.uniq(tags);
    categories = _.uniq(categories);
    const normalizedListId = normalizeId(listId);
    const clearCamelCasedItemData = _.omit(camelCasedItemData, [
        'downloadOptions',
        'mediaStatus',
        'trailerStatus',
    ]);
    const mapAutogeneratedTrailerInfo = (trailer) => {
        const status = normalizeTranscodingStatus(trailer[0].status);
        if (status === TRANSCODING_STATUSES.FAILED) {
            return {
                status,
                errorType: TrailerGenerationErrorType.InternalError,
            };
        }
        else {
            return { status };
        }
    };
    const mappedCamelCasedItemData = {
        ...clearCamelCasedItemData,
        id,
        listId: normalizedListId,
        customCoverUrl,
        transcodingStatus,
        trailerTranscodingStatus,
        dealInfo,
        durationSec,
        durationStr,
        createdTs,
        updatedTs,
        publishTs,
        usedInLists: mapUsedInLists(usedInLists),
        allowDownload,
        videoSource,
        tags,
        categories,
        liveVideoStatus: mapMediaInfoToLiveVideoStatus(mediaInfo, itemType),
        autogeneratedTrailer: mediaInfo?.fileOutput?.trailer?.length
            ? mapAutogeneratedTrailerInfo(mediaInfo?.fileOutput?.trailer)
            : undefined,
    };
    return removeUndefinedValues(mappedCamelCasedItemData);
};
//# sourceMappingURL=video-item.js.map